// Deterministic per-vehicle color palette. Used to give each vehicle a stable
// identity across the multi-vehicle morphed widgets (ProgressGauge stacked
// bars, KPICards efficiency / spend breakdowns, Insights badges).
//
// The first vehicle in the user's `vehicles` array is anchored to Tesla red
// so the existing single-vehicle visual language stays unbroken when the user
// only has one car or filters to one.

const PALETTE = [
  { fill: "#E82127", soft: "rgba(232,33,39,0.18)", text: "#FF5A5F", border: "rgba(232,33,39,0.40)" },
  { fill: "#3B82F6", soft: "rgba(59,130,246,0.18)", text: "#60A5FA", border: "rgba(59,130,246,0.40)" },
  { fill: "#34D17A", soft: "rgba(52,209,122,0.18)", text: "#34D17A", border: "rgba(52,209,122,0.40)" },
  { fill: "#FFB340", soft: "rgba(255,179,64,0.18)", text: "#FFB340", border: "rgba(255,179,64,0.40)" },
  { fill: "#A78BFA", soft: "rgba(167,139,250,0.18)", text: "#A78BFA", border: "rgba(167,139,250,0.40)" },
  { fill: "#22D3EE", soft: "rgba(34,211,238,0.18)", text: "#22D3EE", border: "rgba(34,211,238,0.40)" },
];

/**
 * Returns the color slot for the given vehicle, looked up by its position in
 * the active-vehicles array passed by the caller. Position-based (not hash-
 * based) keeps the mapping stable AND ensures the first car always gets red.
 */
export function colorForVehicle(vehicleId, vehicles = []) {
  const idx = vehicles.findIndex((v) => v.id === vehicleId);
  const slot = idx < 0 ? 0 : idx;
  return PALETTE[slot % PALETTE.length];
}

export function vehiclePalette() {
  return PALETTE;
}
